import React, { useEffect } from "react";
import Spinner, { MiniSpinner } from "../../../layouts/Spinner";
import { connect } from 'react-redux';
import { getQUTemplateSettings, toggleComponent, confirmDialogBox } from "../../../../redux/actions/qu_template_setting/qu_template_setting.actions";


function QUTSList({ loading, qu_template_settings, getQUTemplateSettings, toggleComponent, confirmDialogBox }) {

    useEffect(() => {
        getQUTemplateSettings()
    },[])


    return (
        <div className="row">
            {
                loading ? <div className="col-6 justify-content-center py-5 px-5"><MiniSpinner/></div> :
                <>
                    {
                        qu_template_settings && qu_template_settings.map(qu => (
                            <div className="col-lg-2 col-sm-6 col-12">
                                <div className="card temp-box">
                                    <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                        <div className="mr-auto">
                                            <i className="ft ft-more-horizontal temp-box-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                { !qu.main_template && <button onClick={() => toggleComponent('edit_copy', qu)} class="dropdown-item" type="button">Edit</button> }
                                                { qu.is_default === 1 ? null : !qu.is_custom_template ? <button onClick={() => confirmDialogBox('set_default', qu)} class="dropdown-item" type="button">Set as Default</button> : null }
                                                { qu.main_template ? <button onClick={() => toggleComponent('duplicate-main', qu)} class="dropdown-item" type="button">Duplicate</button> : <button onClick={() => toggleComponent('duplicate', qu)} class="dropdown-item" type="button">Duplicate</button> }
                                            </div>
                                        </div>
                                        <div className="pull-right">
                                           { !qu.main_template && <i onClick={() => confirmDialogBox('archive', qu)} className="ft ft-x temp-box-icon font-weight-bold"></i> }
                                        </div>
                                    </div>
                                    <div className="card-body my-0 p-0">
                                        <img src={qu.template_image} alt="qu" className="img-fluid cursor-pointer"/>
                                    </div>
                                </div>
                                <div className="text-center">{ qu.is_default === 1 && <i className="ft ft-check-circle temp-default-check"></i> } {qu.template_name}</div>
                                {
                                    qu.is_default === 1 && <div className="text-center text-primary"><span className="lbl-status temp-coming-soon">DEFAULT</span></div>
                                }
                            </div>
                        ))
                    }

                    <div className="col-lg-2 col-sm-6 col-12">
                        <div className="card temp-box">
                            <div className="card-header temp-header row py-0 my-0 px-0 mx-0">
                                <div className="m-auto">
                                    <span className="mt-0 lbl-status temp-coming-soon">Coming Soon</span>
                                </div>
                            </div>
                            <div className="card-body my-0 p-0">
                                <span><i className="ft ft-plus-circle temp-plus-icon"></i></span>
                                <img src="/template-setting/blank.png" alt="qu" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}


const mapStateToProps = state => ({
    setting_app: state.setting_app,
    loading: state.qu_template_setting.loading,
    qu_template_settings: state.qu_template_setting.qu_template_settings
});

export default connect(mapStateToProps, { getQUTemplateSettings, toggleComponent, confirmDialogBox })(QUTSList);
